import React, { FunctionComponent, useState } from 'react';
import { Fieldset, Layout } from '@vwfs-bronson/bronson-react';
import { Form, useFormikContext } from 'formik';
import { MockSearchCustomerFormModel } from './formModel';
import { searchFormInputs } from './searchFormInputs';

export const CustomerSearchModalForm: FunctionComponent = () => {
  const { submitForm } = useFormikContext<MockSearchCustomerFormModel>();
  const [inputs] = useState(searchFormInputs);

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    e.stopPropagation();
    // eslint-disable-next-line no-void
    void submitForm();
  };

  return (
    <Fieldset>
      <Form className="u-text-left" onSubmit={handleFormSubmit}>
        <Fieldset.Row>
          <Layout>
            <Layout.Item default="1/2" s="1/1">
              {inputs.firstName()}
            </Layout.Item>
            <Layout.Item default="1/2" s="1/1">
              {inputs.lastName()}
            </Layout.Item>
          </Layout>
        </Fieldset.Row>

        <Fieldset.Row>
          <Layout>
            <Layout.Item default="1/2" s="1/1">
              {inputs.dateOfBirth()}
            </Layout.Item>
            <Layout.Item default="1/2" s="1/1">
              {inputs.email()}
            </Layout.Item>
          </Layout>
        </Fieldset.Row>
      </Form>
    </Fieldset>
  );
};
